import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import {
  DndProvider,
  MultiBackend,
  getBackendOptions,
  ModalsManagerProvider,
  ToastsManagerProvider,
} from "@gusarov-studio/rubik-ui";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import { PersistGate } from "redux-persist/integration/react";
import "./common/styles/index.scss";
import { store, persistor } from "./store";
import { Router } from "./router/Router";
import { localization, LocalizationProvider } from "./modules/localization";
import { initAuthStateListener } from "./modules/auth";
import { AppThemeProvider } from "./modules/preferences";
import { ErrorBoundary } from "./common/components/ErrorBoundary";
import "./tailwind.css";

initAuthStateListener();

const domNode = document.getElementById("root") as HTMLElement;
const root = createRoot(domNode);

store.dispatch(localization.actions.setLocale(localization.locales.EN)).then(() => {
  root.render(
    <StrictMode>
      <Provider store={store}>
        <PersistGate
          loading={null}
          persistor={persistor}
        >
          <ModalsManagerProvider builtInView={false}>
            <ToastsManagerProvider>
              <HelmetProvider>
                <AppThemeProvider>
                  <ErrorBoundary>
                    <LocalizationProvider>
                      <DndProvider
                        backend={MultiBackend}
                        options={getBackendOptions()}
                      >
                        <Router />
                      </DndProvider>
                    </LocalizationProvider>
                  </ErrorBoundary>
                </AppThemeProvider>
              </HelmetProvider>
            </ToastsManagerProvider>
          </ModalsManagerProvider>
        </PersistGate>
      </Provider>
    </StrictMode>,
  );
});
